import PlanDetectionProvider from "@/models/enums/plan-detection-provider";

export enum DetectionCategoryTreatment {
    Range = "Range",
    CM = "CM",
    Step = "Step"
}

export enum DetectionCategory {
    Wall = "Wall",
    Door = "Door",
    Window = "Window"
}

export interface DetectionRangeDTO {
    id: string;
    minCm: number;
    maxCm: number;
    retainedCm: number;
    typeName: string;
}

export interface DetectionCategoryOption {
    enabled: boolean;
    treatment: DetectionCategoryTreatment;
    stepCm: number;
    outsideRanges: "Step" | "Exclude";
    ranges: DetectionRangeDTO[];
}

export interface PlanDetectionOptionsDTO {
    schemaVersion?: number;
    options: Record<DetectionCategory, DetectionCategoryOption>;
}

export interface PlanDetectionConfigurationDTO extends PlanDetectionOptionsDTO {
    schemaVersion: number;
    provider: PlanDetectionProvider;
}

export interface ProjectDetectionConfigurationDTO {
    configuration: PlanDetectionConfigurationDTO;
    rowVersion: string;
}

export default PlanDetectionOptionsDTO;
